import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import FormGroup from '../../../../../../../../FormGroup';
import Button from '../../../../../../../../Button';

const propTypes = {
  currentWidth: PropTypes.number,
  currentHeight: PropTypes.number,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const MeasurementsUpdate = ({
  currentWidth,
  currentHeight,
  onSubmit,
  onClose,
}) => {
  const [width, setWidth] = useState(currentWidth);
  const [height, setHeight] = useState(currentHeight);

  return (
    <Fragment>
      <h4 className="text-center">Update Photo Slot Measurements</h4>
      <FormGroup
        id="width"
        name="width"
        label="Width (inches)"
        placeholder="Enter width..."
        onChange={e => setWidth(e.target.value)}
        value={width}
        type="number"
        step="0.01"
      />
      <FormGroup
        id="height"
        name="height"
        label="Height (inches)"
        placeholder="Enter height..."
        onChange={e => setHeight(e.target.value)}
        value={height}
        type="number"
        step="0.01"
      />
      <div className="mt-2 text-center">
        <Button
          disabled={!width || !height}
          onClick={() => {
            onSubmit({ width, height });
            onClose();
          }}
        >
          Submit
        </Button>
      </div>
    </Fragment>
  );
};

MeasurementsUpdate.propTypes = propTypes;

export default MeasurementsUpdate;
